{
  "main": {
    "title": "Šifrant klubov",
    "nazaj": "Nazaj"
  },
  "navs": {
    "vnos": "Vnos",
    "seznam": "Seznam"
  },
  "table": {
    "sifra":"Šifra",
    "naziv":"Naziv",
    "naslov":"Naslov",
    "podrobno":"podrobno"
  },
  "modal": {
    "sifra":"Šifra:",
    "naziv":"Naziv:",
    "naslov":"Naslov:",
    "posta":"Pošta:",
    "kraj":"Kraj:",
    "email":"Email:",
    "telefon":"Telefon:"
  },
  "buttons": {
    "csv": "Izvoz v csv",
    "uredi":"Uredi podatke",
    "posodobi":"Posodobi podatke",
    "brisi":"Izbriši klub"
  }
}